var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxbolddataSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,4.7c0-0.2,0.1-0.4,0.2-0.7 c0.3-0.5,0.1-1.1-0.4-1.4L9.4,2.1C9,1.9,8.5,2,8.2,2.4L8.2,2.5c-0.5,0.8-1.3,0.8-1.7,0L6.4,2.4C6.1,2,5.6,1.9,5.2,2.1L4.2,2.6 C3.9,2.8,3.7,3.2,3.7,3.5c0,0.2,0,0.3,0.1,0.5C4,4.3,4.1,4.5,4.1,4.7c0,0.5-0.4,0.8-1.1,0.8c-0.5,0-1,0.4-1,1v0.9 c0,0.6,0.5,1,1,1c0.7,0,1.1,0.3,1.1,0.8C4.1,9.5,4,9.7,3.9,10c-0.3,0.5-0.1,1.1,0.4,1.4l0.9,0.5c0.4,0.3,1,0.1,1.2-0.3l0.1-0.1 c0.5-0.8,1.3-0.8,1.7,0l0.1,0.1C8.5,12,9,12.1,9.4,11.9l0.9-0.5c0.3-0.2,0.5-0.5,0.5-0.9c0-0.2,0-0.3-0.1-0.5 c-0.1-0.2-0.2-0.5-0.2-0.7c0-0.5,0.4-0.8,1.1-0.8c0.6,0,1-0.4,1-1V6.5c0-0.5-0.5-1-1-1C10.9,5.5,10.5,5.2,10.5,4.7z M5.6,7 c0-1,0.8-1.7,1.7-1.7S9,6,9,7S8.2,8.7,7.3,8.7S5.6,7.9,5.6,7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9,19.2H17c-0.7,0-1.2-0.6-1.2-1.2v-4.8h2.1c0.4,0,0.6-0.3,0.6-0.8s-0.3-0.8-0.6-0.8h-2.1v-6h2 c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-7C10.4,4.2,10,4.6,10,5s0.3,0.8,0.8,0.8h3.5V18c0,0.5,0.1,0.9,0.4,1.3 c0.5,0.8,1.4,1.4,2.4,1.4h0.9c0.4,0,0.6-0.3,0.6-0.8S18.2,19.2,17.9,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,7.2c-1.2,0-2.2-1-2.2-2.2 s1-2.2,2.2-2.2s2.2,1,2.2,2.2S21.2,7.2,20,7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,14.8c-1.2,0-2.2-1-2.2-2.2 s1-2.2,2.2-2.2s2.2,1,2.2,2.2S21.2,14.8,20,14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,22.2c-1.2,0-2.2-1-2.2-2.2 s1-2.2,2.2-2.2s2.2,1,2.2,2.2S21.2,22.2,20,22.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxbolddataSetting);
export default __webpack_public_path__ + "static/media/vuesaxbolddata-setting.7544a3109c042035c880dfecd81c963f.svg";
export { ForwardRef as ReactComponent };